import React, {useState} from "react";
import {Tabs} from "antd";
import {TabsContainer} from "../../courier/courierDetail/courierDetailStyles";
import {BackOfficePendingPaymentsTab} from "./backofficePendingPaymentsTab/BackOfficePendingPaymentsTab";
import {BackofficeSuccessPaymentsTab} from "./backofficeSuccessPaymentsTab/BackofficeSuccessPaymentsTab";
import {BackofficePendingInvoicePaymentsTab} from "./backofficePendingInvoicePaymentsTab/BackofficePendingInvoicePaymentsTab";
import {BackofficeHasInvoicePaymentsTab} from "./backofficeHasInvoicePaymentsTab/BackofficeHasInvoicePaymentsTab";
import {BackofficeCompletedPaymentsTab} from "./backofficeCompletedPaymentsTab/BackofficeCompletedPaymentsTab";
import {BackofficeFailedPaymentsTab} from "./backofficeFailedPaymentsTab/BackofficeFailedPaymentsTab";
import {BackofficeCanceledPaymentsTab} from "./backofficeCanceledPaymentsTab/BackofficeCanceledPaymentsTab";

import {BackofficeConvertedToCashTab} from "./backofficeConvertedToCashTab/BackofficeConvertedToCashTab";
import {BackOfficePaidByBothCashAndCardTab} from "./backofficePaidByBothCashAndCard/BackofficePaidByBothCashAndCardTab";
export const BackofficeCashOnDeliveryPage = () => {
    const [activeTab, setActiveTab] = useState("pendingPaymentsTab");

    return (
        <TabsContainer activeKey={activeTab} onChange={key => setActiveTab(key)}>
            <Tabs.TabPane tab="Tahsilat Bekleyenler" key="pendingPaymentsTab">
                <BackOfficePendingPaymentsTab isTabOpened={activeTab === "pendingPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Tahsil Edilenler" key="successPaymentsTab">
                <BackofficeSuccessPaymentsTab isTabOpened={activeTab === "successPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Fatura Bekleyen" key="pendingInvoicePaymentsTab">
                <BackofficePendingInvoicePaymentsTab isTabOpened={activeTab === "pendingInvoicePaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Faturası Kesilmiş(Ödeme Bekleyen)" key="hasInvoicePaymentsTab">
                <BackofficeHasInvoicePaymentsTab isTabOpened={activeTab === "hasInvoicePaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Ödemesi Alınan" key="completedPaymentsTab">
                <BackofficeCompletedPaymentsTab isTabOpened={activeTab === "completedPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="İptal Edilen" key="canceledPaymentsTab">
                <BackofficeCanceledPaymentsTab isTabOpened={activeTab === "canceledPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Bankadan Dönen" key="failedPaymentsTab">
                <BackofficeFailedPaymentsTab isTabOpened={activeTab === "failedPaymentsTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Nakite Dönen İşlemler" key="convertedToCashTab">
                <BackofficeConvertedToCashTab isTabOpened={activeTab === "convertedToCashTab"} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Nakit ve Kredi Kartından Aynı Anda Ödeme Alınan İşlemler" key="paidByBothCashAndCardTab">
                <BackOfficePaidByBothCashAndCardTab isTabOpened={activeTab === "paidByBothCashAndCardTab"} />
            </Tabs.TabPane>
        </TabsContainer>
    );
};
